<template>
    <div style="display:inline">
        <ToolButton :Editor="Editor" KnownIcon="Edit" @ToolClick="inLinkEdit = true" :Size="10">

        </ToolButton>
        <vs-popup title="Edit Link" :active.sync="inLinkEdit">
            <vs-input class="w-full mt-5" label-placeholder="Url" v-model="url" type="text"></vs-input>
            <vs-checkbox class="mt-5" v-model="openInNewWindow">Open in new window</vs-checkbox>
            <vs-button style="float: right; margin-top: 17px" @click.stop="saveLink">Save</vs-button>
        </vs-popup>
    </div>
</template>
<script>

import ToolButton from "@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue";

export default ({
    data() {
        return {
            inLinkEdit: false,
            openInNewWindow: false,
            url:'',
        }
    },
    methods: {
        Clicked() {
            this.$emit('Publish');
        },
        saveLink() {
            this.Editor.chain().focus().extendMarkRange('link').setLink({ href: this.url, target: this.openInNewWindow ? '_blank' : '_self' }).run()
            this.inLinkEdit = false;
            this.url = '';
            this.openInNewWindow = false;
        }
    },
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>